import {addMonths, format, isSameMonth, isValid, lastDayOfMonth, subMonths} from "date-fns";

export const CalendarModule = {
    namespaced: true,

    state: {

        start_date_filter: new Date(new Date().getFullYear(), new Date().getMonth()),
        end_date_filter: lastDayOfMonth(addMonths(new Date(), 1)),
        eventTypeFilter: 'All',
        courseFilter: 'All',
        focus_date_filter: new Date(),
        modalOpen: false,
        eventsHold: null,
        expandedPanels: ['announcements'],
        mobileCalendarExpanded: true,
        campus_filter: null,
        colours:{
            event_1_color: '#713e5aff',
            event_2_color: '#63a375ff',
            event_3_color: '#edc79bff',
            event_4_color: '#d57a66ff',
            event_5_color: '#ca6680ff',
            event_6_color: '#407899ff',
            chart_1_color_applications: '#00729A',
            chart_2_color_applications: '#D8D8D8',
            chart_3_color_applications: '#E0650B',
            chart_4_color_applications: '#71BEB2'
        }

    },
    getters: {

        allowTodayClick: state => {
            return !isSameMonth(new Date(), state.focus_date_filter)
        },

        formattedStartDate: state => {
            if (isValid(new Date(state.start_date_filter))) {
                return format((subMonths(new Date(state.start_date_filter), 1)), 'yyyy-MM-dd HH:mm')

            }
            return null
        }, formattedEndDate: state => {
            if (isValid(new Date(state.end_date_filter))) {
                return format(state.end_date_filter, 'yyyy-MM-dd HH:mm')

            }
            return null
        },

    },
    actions: {
        toggleMobileExpand({state}, payload =null) {
            if (payload!==null){
                state.mobileCalendarExpanded = payload
            } else {
                state.mobileCalendarExpanded =  !state.mobileCalendarExpanded
            }
        }, toggleExpand({state}, name) {
            if (state.expandedPanels.includes(name)) {
                state.expandedPanels = state.expandedPanels.filter(panel => {
                    return panel !== name
                })
                return
            }
            state.expandedPanels.push(name)
        },
        set_focus_date({state}, date) {
            let dateObject = new Date(date)
            state.start_date_filter = new Date(dateObject.getFullYear(), dateObject.getMonth())
            state.end_date_filter = lastDayOfMonth(addMonths(dateObject, 1))
            state.focus_date_filter = dateObject

        },

    },


};
